// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f220be69","732":"d4acc8e9","977":"097d5c8a"}[chunkId] + ".chunk.js";
};